/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Incorrect
 *
 * 2 = Correct
 *
 * 3 = Created
 */
export enum DraftStageStatus {
  Incorrect = 1,
  Correct = 2,
  Created = 3,
}
